module.exports = __webpack_public_path__ + "static/media/img_10.ed090403.JPG";